<template>
    <el-form size="mini" :model="form" :inline=true>
        <el-form-item label="转诊日期">
            <el-date-picker
                    v-model="form.startTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="开始日期" style="width: 180px">
            </el-date-picker>
            <span class="split">-</span>
            <el-date-picker
                    v-model="form.endTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="结束日期" style="width: 180px">
            </el-date-picker>
        </el-form-item>
        <el-form-item label="统计类型">
            <el-select v-model="form.kind">
                <el-option v-for="(data,index) in Kind" :key="index" :label="data.name"
                           :value="data.value"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="状态">
            <el-select v-model="form.state">
                <el-option v-for="(data,index) in State" :key="index" :label="data.name"
                           :value="data.value"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item>
            <el-button type="success" @click="$emit('query')">查询</el-button>
            <el-button type="primary" @click="$emit('writeExcel')">导出报表</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
    import {getOneYearTime,getOneMonTime} from '../../lib/hos/until';
    export default {
        name: "hos-statistics-search-from",
        data(){
            return {
                form:{
                    startTime:'',
                    endTime:'',
                    kind:'all',
                    state:'all'
                },
                State:[{name:"全部",value:'all'},{name:"待处理",value:'2'},{name:"已完成",value:'4'},{name:"已取消",value:'-2,-1'}],
                Kind:[{name:"全部",value:'all'},{name:"发起的",value:'init'},{name:"接收的",value:'accept'}]
            }
        },
        methods:{
            //设置默认时间
            setDefalutTime(){
                const timeObj = getOneMonTime();
                this.form.endTime = timeObj.end;
                this.form.startTime = timeObj.start;
            },
            getForm(){
                let form = {};
                form.startTime = this.form.startTime;
                form.endTime = this.form.endTime;
                if(this.form.kind != 'all'){
                    form.aspectUser =this.form.kind;
                }
                if(this.form.state != 'all'){
                    form.referralStatusList =this.form.state.split(',');
                }
                return form
            }
        },
        created() {
            this.setDefalutTime();
        }
    }
</script>

<style lang="scss" scoped>
    .split{
        margin: 0 10px;
        color:#999999
    }
</style>